import {
    createFieldInput,
} from "../../../../components/input/template-builder/template-builder.logic";
import i18n from "../../../../i18n";
import { createColumnInput } from "../../../../components/table/c-table.logic";
import lodash from "lodash";
import { conditionFormChecker, putField } from "../../../../utils/form";
import { defineAsyncComponent } from "vue";

const Address = defineAsyncComponent(() => import('../../../../components/address/Address'))
const TemplateBuilder = defineAsyncComponent(() => import('../../../../components/input/template-builder/TemplateBuilder'))

export const createColumns = () => {
    const columns = [
        createColumnInput({ title: () => i18n.global.t("model.department.nameTh"), dataIndex: "nameTh", align: 'center' }),
        createColumnInput({ title: () => i18n.global.t("model.department.nameEn"), dataIndex: "nameEn", align: 'center' }),
    ]
    return columns
}

export const createFieldDepartment = ({ props, data }) => {
    const viewOnly = props.viewOnly
    const useForm = data.useForm
    const modelRef = useForm.modelRef
    return putField({
        data, fields: [
            createFieldInput({
                key: 'nameTh',
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 18 } }),
                label: () => i18n.global.t('model.department.nameTh'),
                inputProp: () => ({
                    value: modelRef.nameTh,
                    'onUpdate:value': value => modelRef.nameTh = value,
                    disabled: viewOnly
                })
            }),
            createFieldInput({
                key: 'nameEn',
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 18 } }),
                label: () => i18n.global.t('model.department.nameEn'),
                inputProp: () => ({
                    value: modelRef.nameEn,
                    'onUpdate:value': value => modelRef.nameEn = value,
                    disabled: viewOnly
                })
            }),
        ]
    })
}

export const createFieldAddress = ({ props, data, key, isLoading }) => {
    const { viewOnly, menuContext } = props
    const { useForm } = data
    const { modelRef } = useForm
    const model = key ? lodash.get(modelRef, key) : modelRef
    const prefix = key ? `${key}.` : ''
    return putField({
        data, fields: [
            {
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: 'visibleField', params: { field } }),
                colProp: () => ({ xs: 24 }),
                formItemRender: () => <div>
                    <Address menuContext={menuContext}
                             dataProp={data}
                             dataKey={`${prefix}refAddr`}
                             viewOnly={viewOnly}
                             isLoading={isLoading.value}
                             onUpdateSome={() => {
                                 model.refAddr.isSave = true
                             }}
                             ></Address>
                </div>,
            }
        ]
    })
}

export const createField = ({ props, data, key, isLoading }) => {
    return putField({
        data, fields: [
            {
                visible: () => true,
                colProp: () => ({ xs: 24 }),
                formItemRender: () =>
                    <TemplateBuilder
                        rowProp={data.rowProp}
                        useForm={data.useForm}
                        fields={createFieldDepartment({ props, data, key, isLoading })}
                        skeleton={isLoading.value}
                    ></TemplateBuilder>
            },
            {
                visible: () => true,
                colProp: () => ({ xs: 24 }),
                formItemRender: () =>
                    <TemplateBuilder
                        rowProp={data.rowProp}
                        useForm={data.useForm}
                        fields={createFieldAddress({ props, data, key, isLoading })}
                        skeleton={isLoading.value}
                    ></TemplateBuilder>
            },
        ]
    })
}